import gsap from "gsap";

function filterAwards(ids) {
  $('.awards-wrap .award-item').hide();

  ids.forEach((id) => {
    $(`.awards-wrap .award-item[data-award-id="${id}"]`).show();
  });
}

export default {
  init() {
    // Filter depending on query parameter
    const query = new URLSearchParams(window.location.search);
    const ids = query.get('award-ids');
    if (ids) {
      filterAwards(ids.split(',').map((id) => parseInt(id, 10)));
    }
  },
  finalize() {

        //Funds general animation
        let awardsWrap = document.querySelector('.awards-wrap');
        let awardItems = gsap.utils.toArray(awardsWrap.children);
    
        const awardsTimeLine = gsap.timeline();
        const tween = gsap.fromTo(awardItems,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          duration: 1,
          stagger: 0.2,
          ease: 'power2.easeOut',
        });
    
        awardsTimeLine.add(tween);
        awardsTimeLine.play();

    // Open filter by category
    $('.filter-box-header .filter-box-open').on('click', function() {
      $('.filter-box-open').hide();
      $('.filter-box-close').show();

      $('.filter-box-body').show();
    });
    
    // Close filter by category
    $('.filter-box-header .filter-box-close').on('click', function() {
      $('.filter-box-close').hide();
      $('.filter-box-open').show();

      $('.filter-box-body').hide();
    });

    // Change filter category
    $('.filter-box-body .filter-box-categories .category-btn').on('click', function() {
      const category = $(this).data('category');

      // Close all other filters
      $('.filter-box-body .filter-box-selections').hide();
      $('.filter-box-body .filter-box-categories .category-btn').removeClass('active');

      // Open this filter
      $(`.filter-box-body .filter-box-selections[data-category="${category}"]`).show();
      $(this).addClass('active');
    });

    // Select a filter box
    $('.filter-box-body .filter-box-selections .filter-box-selection').on('click', function() {
      const awards = $(this).data('awards');

      // Close all other filters and select this one
      $('.filter-box-body .filter-box-selections .filter-box-selection').removeClass('active');
      $(this).addClass('active');

      // Hide all awards and then iterate through the awards IDs for this selection
      $('.awards-wrap .award-item').hide();

      if (awards.length > 0) {
        filterAwards(awards);
      }

      console.log("clicked");
      triggerFundsAnimation();
    });

    //
    function triggerFundsAnimation() {
      awardsWrap = document.querySelector('.awards-wrap');

      let awardItems = gsap.utils.toArray(awardsWrap.children);
      let activeItems = [];

      awardItems.forEach(function(item) {
        //check if award item is currently being shown.
        //if true add to new activeItems filtered array.
        console.log('style is currently: ' + item.style.display);
        if(item.style.display != 'none') {
          activeItems.push(item);
          console.log('item added');
        }
      })

      console.log(activeItems );

        const tl = gsap.timeline();
        const tween = gsap.fromTo(activeItems,
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          duration: 1,
          stagger: 0.2,
          ease: 'power2.easeOut',
        });
        tl.add(tween);

        //Restart filter animation on selecting a new option
        tl.play();
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateFunds.js